
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
//@ts-expect-error
var $7d29c8b824b6496c$exports = {};
$7d29c8b824b6496c$exports = JSON.parse("{\"metrics\":{\"height\":9,\"width\":7,\"spaces\":4},\"alphabet\":\"?1234567890!          ABCDEFGHIJKabcdefghijkLMNOPQRSTUVlmnopqrstuvWXYZ       wxyz\",\"characters\":[[7,[0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,1,0,0,0,1,0,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0]],[4,[0,0,0,0,0,0,1,0,0,1,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,1,1,0,0,0,1,0,0,1,0,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,1,1,0,0,0,1,0,0,1,0,0,0,0,0,1,0,0,0,1,1,0,0,0,0,0,0,1,0,0,1,0,0,1,0,0,0,1,1,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,1,1,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,1,1,1,1,0,0,1,0,0,0,0,0,1,0,0,0,0,0,1,1,1,0,0,0,0,0,0,1,0,0,0,0,0,1,0,0,1,1,1,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,1,1,0,0,0,1,0,0,1,0,0,1,0,0,0,0,0,1,1,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,1,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,1,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,1,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,1,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,1,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,1,1,0,0,0,0,0,1,0,0,1,0,0,1,0,0,0,1,1,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,1,1,0,0,0,1,0,0,1,0,0,1,0,1,1,0,0,1,1,1,1,0,0,1,1,0,1,0,0,1,0,0,1,0,0,0,1,1,0,0,0,0,0,0,0,0]],[3,[0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,0,0,1,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,1,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,1,1,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,1,1,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,1,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,1,1,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,1,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,1,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,1,1,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,1,1,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,1,1,1,0,0,1,0,0,0,0,0,1,0,0,0,0,0,1,1,1,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0]],[5,[0,0,0,0,0,0,0,1,1,1,0,1,0,0,0,0,1,0,0,0,0,1,1,1,0,0,1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,1,1,0,0,0,1,0,0,1,0,0,1,0,0,0,0,0,1,0,1,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,1,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,1,1,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,0,0,0,0]],[3,[0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,1,0,0,1,0,0,1,0,0,0,1,1,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,1,0,0,0,1,1,0,0,0,0,1,0,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,1,0,0,0,1,1,1,0,0,1,0,0,1,0,0,0,1,1,1,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,1,1,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,1,0,0,0,0,0,0,0,0]],[5,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,0,1,1,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,1,1,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,1,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,1,0,0,1,0,0,1,1,1,1,0,0,1,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0]],[4,[0,0,0,0,0,0,1,1,0,1,0,0,0,1,1,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,1,0,0,0,0,0,1,0,1,1,0,0,1,0,0,1,0,0,0,1,1,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,1,1,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,0,0,0,0]],[3,[0,0,0,0,1,0,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,0]],[5,[0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1,0,0,1,0,1,0,0,0,1,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,1,0,0,1,0,0,1,0,1,0,0,0,1,1,0,0,0,0,1,0,1,0,0,0,1,0,0,1,0,0,0,0,0,0,0]],[5,[0,0,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1,1,1,1,0,0,0,0,0]],[7,[0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,1,1,0,1,1,0,0,1,0,1,0,1,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,0,0,0,0,0,0]],[7,[0,0,0,0,0,0,0,0,1,1,0,0,1,0,0,1,1,0,0,1,0,0,1,0,1,0,1,0,0,1,0,1,0,1,0,0,1,0,1,0,1,0,0,1,0,0,1,1,0,0,1,0,0,1,1,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,1,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,1,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,1,1,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,1,1,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,1,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,1,1,0,0,0,1,1,1,1,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,1,1,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,1,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,1,1,0,0,0,1,0,0,1,0,0,1,0,0,0,0,0,0,1,1,0,0,0,0,0,0,1,0,0,1,0,0,1,0,0,0,1,1,0,0,0,0,0,0,0,0]],[5,[0,0,0,0,0,1,1,1,1,1,0,0,1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,1,0,0,0,0,0,0,0,0]],[7,[0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,0,1,0,1,0,0,0,0,1,0,1,0,0,0,0,0,1,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0]],[4,[0,0,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,0,1,1,0,0,0,0]],[7,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,1,0,0,0,1,0,1,0,1,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,0,1,1,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,0,1,0,0,1,0,0,1,1,1,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,1,0,0,1,0,0,0,1,1,1,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,0,0]],[5,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,1,0,0,0,0,0,0,1,1,0,0,0,0,0,0,1,0,0,1,1,1,0,0,0,0,0,0,0,0]],[5,[0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,1,1,0,0,0,1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,0]],[5,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,1,0,0,1,0,1,0,0,1,0,1,0,0,1,0,1,0,0,0,1,0,0,0,0,0,0,0]],[5,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,1,0,0,1,0,1,0,0,1,0,1,0,0,0,1,0,0,0,0,1,0,0,0,0,0,0,0]],[7,[0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,1,0,1,0,1,0,0,1,0,1,0,1,0,0,0,1,0,1,0,0,0,0,1,0,1,0,0,0,0,0,0,0,0,0]],[7,[0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,0,1,0,1,0,0,0,0,0,1,0,0,0,0,0,1,0,1,0,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,0,0,0,0,0,0]],[7,[0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,0,1,0,1,0,0,0,0,0,1,0,0,0,0,0,0,1,0,0,0,0,0,0,1,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1,1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[7,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,1,0,1,0,1,0,0,1,0,1,0,1,0,0,0,1,0,1,0,0,0,0,1,0,1,0,0,0,0,0,0,0,0,0]],[7,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,1,0,1,0,0,0,0,0,1,0,0,0,0,0,1,0,1,0,0,0,1,0,0,0,1,0,0,0,0,0,0,0,0]],[7,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,1,0,1,0,0,0,0,0,1,0,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,0,1,0,0,0,1,1,0,0,0,1,0,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]]]}");


var $5de14f50af6b7750$exports = {};
$5de14f50af6b7750$exports = JSON.parse("{\"metrics\":{\"height\":13,\"width\":10,\"spaces\":4},\"alphabet\":\"*1234567890           ABCDEFGHIJKLMNOPQRSTUVWXYZ       \",\"characters\":[[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,0,0,1,1,1,1,0,1,1,1,1,0,1,1,0,1,0,0,1,0,1,1,1,0,0,0,0,1,1,1,0,0,0,0,0,0,1,1,1,0,0,0,0,1,1,1,0,1,0,0,1,0,1,1,0,1,1,1,1,0,1,1,1,1,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,0,0,0,1,1,0,0,0,0,0,0,1,1,0,0,0,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,1,1,0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,1,0,0,1,0,0,1,1,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,1,1,1,0,0,1,1,1,1,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,1,1,0,0,1,1,0,0,1,0,0,0,1,0,0,1,1,0,0,1,1,0,1,1,0,0,1,1,0,0,1,0,0,0,1,1,1,1,1,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,1,1,1,1,0,0,1,0,1,0,0,0,0,1,1,1,1,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,1,1,0,0,0,1,0,1,1,0,1,0,0,1,1,1,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,0,0,0,0,1,1,1,1,1,1,0,0,1,0,0,0,1,1,0,0,1,0,0,0,1,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,1,1,0,0,1,1,1,1,1,1,0,0,1,1,1,1,0,1,0,0,0,0,0,1,1,1,1,1,1,0,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,1,1,1,0,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,1,1,1,0,0,1,0,0,0,1,0,0,1,1,0,0,1,1,0,0,1,0,0,0,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,0,0,0,0,1,0,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,0,1,1,1,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,0,0,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,0,1,0,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[7,[0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,0,0,0,0,1,1,0,0,1,1,1,1,1,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,1,1,1,1,1,1,0,0,0,0,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,0,1,0,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,1,1,0,0,1,1,1,1,1,1,0,0,1,1,1,0,0,1,0,0,0,0,1,0,0,1,0,0,1,1,1,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,1,1,1,1,1,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,1,1,0,0,1,1,1,1,1,1,0,0,1,1,1,0,0,1,0,0,0,0,1,0,0,1,0,0,1,1,1,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,1,1,1,0,0,1,0,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,0,0,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0]],[6,[0,0,0,0,0,0,1,1,1,1,1,1,1,0,0,0,0,1,1,1,0,0,1,1,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,0,1,0,1,1,0,0,1,1,1,0,0,0,0,1,1,1,1,1,1,1,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,1,1,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,0,1,1,1,1,0,0,0,1,1,0,0,1,0,0,1,0,1,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0]],[7,[0,0,0,0,0,0,0,1,1,1,1,0,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,1,0,0,0,1,0,0,1,1,1,1,1,0,0,0,0,0,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0]],[10,[0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,1,1,1,1,1,0,0,1,1,1,1,0,0,1,1,0,0,0,1,1,0,0,0,1,1,0,0,1,0,0,1,0,0,1,1,0,0,1,1,1,1,0,0,1,1,0,0,1,0,0,1,0,0,1,1,0,0,1,0,0,1,0,0,1,1,0,0,1,0,0,1,0,0,1,1,0,0,1,0,0,1,0,0,1,1,0,0,1,0,0,1,0,0,1,1,1,1,1,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0]],[9,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,1,0,0,0,1,1,0,0,1,1,0,0,0,1,1,0,0,1,1,0,0,0,1,1,0,0,1,1,0,0,1,0,1,0,0,1,1,0,0,1,0,1,0,0,1,1,0,0,1,0,1,0,0,1,1,0,0,1,1,0,0,0,1,1,0,0,1,1,0,0,0,1,1,0,0,1,1,0,0,0,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,0,1,0,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,0,0,0,1,1,1,0,0,1,1,1,1,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,0,1,0,1,1,1,1,1,0,0,0,0,0,0,0,1,1,1]],[8,[0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,0,1,0,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,1,1,0,0,1,1,1,1,1,1,0,0,1,1,1,1,0,1,1,0,0,0,0,1,1,0,1,1,1,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,1,1,1,1,1,0,0,1,1,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,1,1,1,1,0,0,1,1,1,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,0,0,0,0,1,0,0,1,1,0,0,1,1,0,0,0,1,0,0,1,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0]],[10,[0,0,0,0,0,0,0,0,0,0,1,1,1,1,0,0,1,1,1,1,1,0,0,1,0,0,1,0,0,1,1,0,0,1,0,0,1,0,0,1,1,0,0,1,0,0,1,0,0,1,1,0,0,1,0,0,1,0,0,1,1,0,0,1,0,0,1,0,0,1,1,0,0,1,1,1,1,0,0,1,1,0,0,1,0,0,1,0,0,1,1,0,0,0,0,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,0,0,1,1,0,0,1,0,0,0,0,1,0,1,1,0,1,1,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,0,0,1,1,0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,0,0,1,0,0,0,0,1,1,1,1,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,1,1,1,1,1,1,0,0,1,0,0,0,1,0,0,1,1,0,0,1,1,0,0,1,0,0,1,1,0,0,1,1,0,0,1,0,0,1,1,0,0,1,1,0,0,1,0,0,0,1,0,0,1,1,1,1,1,1,0,0,0,0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,1,1,1,1,1,1,0,1,1,0,0,0,0,1,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,0,0,1,1,1,0,0,0,0,1,1,0,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],[8,[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]]]}");


/*
eslint-disable no-restricted-imports
*/ /*
eslint-disable no-restricted-imports
*/ const $a5ee77bd64375024$export$5f7f9c42ca0cfe95 = (coords, layer)=>coords.y * layer.x + coords.x;
const $a5ee77bd64375024$export$cdddc5dc0b5a25e4 = (index, layer)=>{
    const pixelIndex = ~~index;
    return {
        x: pixelIndex % layer.x,
        y: ~~(pixelIndex / layer.x)
    };
};
const $a5ee77bd64375024$export$7ee2609c9d01f742 = (coords, layer)=>{
    const normalXYCoords = $a5ee77bd64375024$var$normalize(coords, layer);
    if (!normalXYCoords) return null;
    return layer.pixels[$a5ee77bd64375024$export$5f7f9c42ca0cfe95(coords, layer)];
};
const $a5ee77bd64375024$var$normalize = (coords, layer)=>{
    const x = ~~coords.x;
    const y = ~~coords.y;
    if (x >= layer.x || x < 0) return null;
    if (y >= layer.y || y < 0) return null;
    return {
        x: x,
        y: y
    };
};


const $8eba8339316108f6$export$912a92c4dfa79ecb = {
    x: 0,
    y: 0
};
const $8eba8339316108f6$export$5551a2d24ff40153 = (0, $a5ee77bd64375024$export$7ee2609c9d01f742);
const $8eba8339316108f6$export$94c12620b65d3208 = (0, $a5ee77bd64375024$export$cdddc5dc0b5a25e4);
const $8eba8339316108f6$export$cf0d5f39e99a45f1 = (0, $a5ee77bd64375024$export$5f7f9c42ca0cfe95);



const $a978050f7a8d3fb1$export$e63d87d551c43f6 = (color)=>()=>color;
const $a978050f7a8d3fb1$export$442e6c70d6c590be = (size = 1, borderColor = (0, $3c901d31e89c6ceb$export$b2b4e19872dae74).BLACK, innerColor = (0, $3c901d31e89c6ceb$export$b2b4e19872dae74).ALPHA)=>(index, layer)=>{
        const { x: x, y: y } = (0, $8eba8339316108f6$export$94c12620b65d3208)(index, layer);
        if (y < size || layer.y - size <= y) return borderColor;
        if (x < size || layer.x - size <= x) return borderColor;
        return innerColor;
    };
const $a978050f7a8d3fb1$export$116f189a93694d5b = ()=>()=>(0, $3c901d31e89c6ceb$export$b2b4e19872dae74).ALPHA;


/**
  hex values from -1 (see alpha to 0xffffff) matching web colors
 */ const $3c901d31e89c6ceb$export$b2b4e19872dae74 = {
    ALPHA: -1,
    WHITE: 0xffffff,
    BLACK: 0x000000,
    RED: 0xff0000,
    GREEN: 0x00ff00,
    BLUE: 0x0000ff
};
const $3c901d31e89c6ceb$export$57d988dae4711c70 = (color)=>{
    return color === -1;
};
const $3c901d31e89c6ceb$export$36e66100fecf59cf = (r, g, b)=>{
    return r << 16 | g << 8 | b;
};
const $3c901d31e89c6ceb$export$170d64abcc52d97a = (color)=>{
    const r = color >> 24 & 0xff;
    const g = color >> 16 & 0xff;
    const b = color >> 8 & 0xff;
    if ($3c901d31e89c6ceb$export$57d988dae4711c70(color)) return [
        r,
        g,
        b
    ];
    const a = color & 0xff;
    return [
        g,
        b,
        a
    ];
};
const $3c901d31e89c6ceb$export$33ee99e9ec522cbf = (top, bottom)=>{
    if (top == null) return bottom;
    if ($3c901d31e89c6ceb$export$57d988dae4711c70(top)) return bottom;
    return top;
};
const $3c901d31e89c6ceb$export$9a2497f3dd4b2361 = (r)=>{
    return ~~(r * 0xffffff);
};


const $1e0e3a956a824c28$export$da5d6544e8c27bc1 = {
    /**
  Paints the whole area in a single color. fast.
  */ solidFill: (0, $a978050f7a8d3fb1$export$e63d87d551c43f6),
    /**
  Paints a border of x size
  */ border: (0, $a978050f7a8d3fb1$export$442e6c70d6c590be),
    /**
  Paints a whole area in alpha
  */ alphaSolidFill: (0, $a978050f7a8d3fb1$export$116f189a93694d5b)
};
const $1e0e3a956a824c28$export$6d1b0a04fee90d44 = {
    /**
  RGB to Hex color
  */ fromRGB: (0, $3c901d31e89c6ceb$export$36e66100fecf59cf),
    /**
  Hex color to RGB
  */ toRGB: (0, $3c901d31e89c6ceb$export$170d64abcc52d97a)
};
const $1e0e3a956a824c28$export$90a1dddd794186f = (0, $3c901d31e89c6ceb$export$9a2497f3dd4b2361);
const $1e0e3a956a824c28$export$4f1b4fd0a80ed3b5 = (0, $3c901d31e89c6ceb$export$57d988dae4711c70);


/**
 * Decode bytes to text
 * @param bytes - Bytes to decode
 * @param encoding - Text encoding
 * @returns The decoded text
 */ function $956dd9b222f51e03$export$2f872c0f2117be69(bytes, encoding = 'utf8') {
    const decoder = new TextDecoder(encoding);
    return decoder.decode(bytes);
}
const $956dd9b222f51e03$var$encoder = new TextEncoder();
function $956dd9b222f51e03$export$c564cdbbe6da493(str) {
    return $956dd9b222f51e03$var$encoder.encode(str);
}


const $1a3e0bc2b2fb1c0c$var$defaultByteLength = 8192;
const $1a3e0bc2b2fb1c0c$var$hostBigEndian = (()=>{
    const array = new Uint8Array(4);
    const view = new Uint32Array(array.buffer);
    return !((view[0] = 1) & array[0]);
})();
const $1a3e0bc2b2fb1c0c$var$typedArrays = {
    int8: globalThis.Int8Array,
    uint8: globalThis.Uint8Array,
    int16: globalThis.Int16Array,
    uint16: globalThis.Uint16Array,
    int32: globalThis.Int32Array,
    uint32: globalThis.Uint32Array,
    uint64: globalThis.BigUint64Array,
    int64: globalThis.BigInt64Array,
    float32: globalThis.Float32Array,
    float64: globalThis.Float64Array
};
class $1a3e0bc2b2fb1c0c$export$6b4c32f3d5b8738a {
    /**
     * Reference to the internal ArrayBuffer object.
     */ buffer;
    /**
     * Byte length of the internal ArrayBuffer.
     */ byteLength;
    /**
     * Byte offset of the internal ArrayBuffer.
     */ byteOffset;
    /**
     * Byte length of the internal ArrayBuffer.
     */ length;
    /**
     * The current offset of the buffer's pointer.
     */ offset;
    lastWrittenByte;
    littleEndian;
    _data;
    _mark;
    _marks;
    /**
     * Create a new IOBuffer.
     * @param data - The data to construct the IOBuffer with.
     * If data is a number, it will be the new buffer's length<br>
     * If data is `undefined`, the buffer will be initialized with a default length of 8Kb<br>
     * If data is an ArrayBuffer, SharedArrayBuffer, an ArrayBufferView (Typed Array), an IOBuffer instance,
     * or a Node.js Buffer, a view will be created over the underlying ArrayBuffer.
     * @param options - An object for the options.
     * @returns A new IOBuffer instance.
     */ constructor(data = $1a3e0bc2b2fb1c0c$var$defaultByteLength, options = {}){
        let dataIsGiven = false;
        if (typeof data === 'number') data = new ArrayBuffer(data);
        else {
            dataIsGiven = true;
            this.lastWrittenByte = data.byteLength;
        }
        const offset = options.offset ? options.offset >>> 0 : 0;
        const byteLength = data.byteLength - offset;
        let dvOffset = offset;
        if (ArrayBuffer.isView(data) || data instanceof $1a3e0bc2b2fb1c0c$export$6b4c32f3d5b8738a) {
            if (data.byteLength !== data.buffer.byteLength) dvOffset = data.byteOffset + offset;
            data = data.buffer;
        }
        if (dataIsGiven) this.lastWrittenByte = byteLength;
        else this.lastWrittenByte = 0;
        this.buffer = data;
        this.length = byteLength;
        this.byteLength = byteLength;
        this.byteOffset = dvOffset;
        this.offset = 0;
        this.littleEndian = true;
        this._data = new DataView(this.buffer, dvOffset, byteLength);
        this._mark = 0;
        this._marks = [];
    }
    /**
     * Checks if the memory allocated to the buffer is sufficient to store more
     * bytes after the offset.
     * @param byteLength - The needed memory in bytes.
     * @returns `true` if there is sufficient space and `false` otherwise.
     */ available(byteLength = 1) {
        return this.offset + byteLength <= this.length;
    }
    /**
     * Check if little-endian mode is used for reading and writing multi-byte
     * values.
     * @returns `true` if little-endian mode is used, `false` otherwise.
     */ isLittleEndian() {
        return this.littleEndian;
    }
    /**
     * Set little-endian mode for reading and writing multi-byte values.
     * @returns This.
     */ setLittleEndian() {
        this.littleEndian = true;
        return this;
    }
    /**
     * Check if big-endian mode is used for reading and writing multi-byte values.
     * @returns `true` if big-endian mode is used, `false` otherwise.
     */ isBigEndian() {
        return !this.littleEndian;
    }
    /**
     * Switches to big-endian mode for reading and writing multi-byte values.
     * @returns This.
     */ setBigEndian() {
        this.littleEndian = false;
        return this;
    }
    /**
     * Move the pointer n bytes forward.
     * @param n - Number of bytes to skip.
     * @returns This.
     */ skip(n = 1) {
        this.offset += n;
        return this;
    }
    /**
     * Move the pointer n bytes backward.
     * @param n - Number of bytes to move back.
     * @returns This.
     */ back(n = 1) {
        this.offset -= n;
        return this;
    }
    /**
     * Move the pointer to the given offset.
     * @param offset - The offset to move to.
     * @returns This.
     */ seek(offset) {
        this.offset = offset;
        return this;
    }
    /**
     * Store the current pointer offset.
     * @see {@link IOBuffer#reset}
     * @returns This.
     */ mark() {
        this._mark = this.offset;
        return this;
    }
    /**
     * Move the pointer back to the last pointer offset set by mark.
     * @see {@link IOBuffer#mark}
     * @returns This.
     */ reset() {
        this.offset = this._mark;
        return this;
    }
    /**
     * Push the current pointer offset to the mark stack.
     * @see {@link IOBuffer#popMark}
     * @returns This.
     */ pushMark() {
        this._marks.push(this.offset);
        return this;
    }
    /**
     * Pop the last pointer offset from the mark stack, and set the current
     * pointer offset to the popped value.
     * @see {@link IOBuffer#pushMark}
     * @returns This.
     */ popMark() {
        const offset = this._marks.pop();
        if (offset === undefined) throw new Error('Mark stack empty');
        this.seek(offset);
        return this;
    }
    /**
     * Move the pointer offset back to 0.
     * @returns This.
     */ rewind() {
        this.offset = 0;
        return this;
    }
    /**
     * Make sure the buffer has sufficient memory to write a given byteLength at
     * the current pointer offset.
     * If the buffer's memory is insufficient, this method will create a new
     * buffer (a copy) with a length that is twice (byteLength + current offset).
     * @param byteLength - The needed memory in bytes.
     * @returns This.
     */ ensureAvailable(byteLength = 1) {
        if (!this.available(byteLength)) {
            const lengthNeeded = this.offset + byteLength;
            const newLength = lengthNeeded * 2;
            const newArray = new Uint8Array(newLength);
            newArray.set(new Uint8Array(this.buffer));
            this.buffer = newArray.buffer;
            this.length = newLength;
            this.byteLength = newLength;
            this._data = new DataView(this.buffer);
        }
        return this;
    }
    /**
     * Read a byte and return false if the byte's value is 0, or true otherwise.
     * Moves pointer forward by one byte.
     * @returns The read boolean.
     */ readBoolean() {
        return this.readUint8() !== 0;
    }
    /**
     * Read a signed 8-bit integer and move pointer forward by 1 byte.
     * @returns The read byte.
     */ readInt8() {
        return this._data.getInt8(this.offset++);
    }
    /**
     * Read an unsigned 8-bit integer and move pointer forward by 1 byte.
     * @returns The read byte.
     */ readUint8() {
        return this._data.getUint8(this.offset++);
    }
    /**
     * Alias for {@link IOBuffer#readUint8}.
     * @returns The read byte.
     */ readByte() {
        return this.readUint8();
    }
    /**
     * Read `n` bytes and move pointer forward by `n` bytes.
     * @param n - Number of bytes to read.
     * @returns The read bytes.
     */ readBytes(n = 1) {
        return this.readArray(n, 'uint8');
    }
    /**
     * Creates an array of corresponding to the type `type` and size `size`.
     * For example, type `uint8` will create a `Uint8Array`.
     * @param size - size of the resulting array
     * @param type - number type of elements to read
     * @returns The read array.
     */ readArray(size, type) {
        const bytes = $1a3e0bc2b2fb1c0c$var$typedArrays[type].BYTES_PER_ELEMENT * size;
        const offset = this.byteOffset + this.offset;
        const slice = this.buffer.slice(offset, offset + bytes);
        if (this.littleEndian === $1a3e0bc2b2fb1c0c$var$hostBigEndian && type !== 'uint8' && type !== 'int8') {
            const slice = new Uint8Array(this.buffer.slice(offset, offset + bytes));
            slice.reverse();
            const returnArray = new $1a3e0bc2b2fb1c0c$var$typedArrays[type](slice.buffer);
            this.offset += bytes;
            returnArray.reverse();
            return returnArray;
        }
        const returnArray = new $1a3e0bc2b2fb1c0c$var$typedArrays[type](slice);
        this.offset += bytes;
        return returnArray;
    }
    /**
     * Read a 16-bit signed integer and move pointer forward by 2 bytes.
     * @returns The read value.
     */ readInt16() {
        const value = this._data.getInt16(this.offset, this.littleEndian);
        this.offset += 2;
        return value;
    }
    /**
     * Read a 16-bit unsigned integer and move pointer forward by 2 bytes.
     * @returns The read value.
     */ readUint16() {
        const value = this._data.getUint16(this.offset, this.littleEndian);
        this.offset += 2;
        return value;
    }
    /**
     * Read a 32-bit signed integer and move pointer forward by 4 bytes.
     * @returns The read value.
     */ readInt32() {
        const value = this._data.getInt32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    /**
     * Read a 32-bit unsigned integer and move pointer forward by 4 bytes.
     * @returns The read value.
     */ readUint32() {
        const value = this._data.getUint32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    /**
     * Read a 32-bit floating number and move pointer forward by 4 bytes.
     * @returns The read value.
     */ readFloat32() {
        const value = this._data.getFloat32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    /**
     * Read a 64-bit floating number and move pointer forward by 8 bytes.
     * @returns The read value.
     */ readFloat64() {
        const value = this._data.getFloat64(this.offset, this.littleEndian);
        this.offset += 8;
        return value;
    }
    /**
     * Read a 64-bit signed integer number and move pointer forward by 8 bytes.
     * @returns The read value.
     */ readBigInt64() {
        const value = this._data.getBigInt64(this.offset, this.littleEndian);
        this.offset += 8;
        return value;
    }
    /**
     * Read a 64-bit unsigned integer number and move pointer forward by 8 bytes.
     * @returns The read value.
     */ readBigUint64() {
        const value = this._data.getBigUint64(this.offset, this.littleEndian);
        this.offset += 8;
        return value;
    }
    /**
     * Read a 1-byte ASCII character and move pointer forward by 1 byte.
     * @returns The read character.
     */ readChar() {
        // eslint-disable-next-line unicorn/prefer-code-point
        return String.fromCharCode(this.readInt8());
    }
    /**
     * Read `n` 1-byte ASCII characters and move pointer forward by `n` bytes.
     * @param n - Number of characters to read.
     * @returns The read characters.
     */ readChars(n = 1) {
        let result = '';
        for(let i = 0; i < n; i++)result += this.readChar();
        return result;
    }
    /**
     * Read the next `n` bytes, return a UTF-8 decoded string and move pointer
     * forward by `n` bytes.
     * @param n - Number of bytes to read.
     * @returns The decoded string.
     */ readUtf8(n = 1) {
        return (0, $956dd9b222f51e03$export$2f872c0f2117be69)(this.readBytes(n));
    }
    /**
     * Read the next `n` bytes, return a string decoded with `encoding` and move pointer
     * forward by `n` bytes.
     * If no encoding is passed, the function is equivalent to @see {@link IOBuffer#readUtf8}
     * @param n - Number of bytes to read.
     * @param encoding - The encoding to use. Default is 'utf8'.
     * @returns The decoded string.
     */ decodeText(n = 1, encoding = 'utf8') {
        return (0, $956dd9b222f51e03$export$2f872c0f2117be69)(this.readBytes(n), encoding);
    }
    /**
     * Write 0xff if the passed value is truthy, 0x00 otherwise and move pointer
     * forward by 1 byte.
     * @param value - The value to write.
     * @returns This.
     */ writeBoolean(value) {
        this.writeUint8(value ? 0xff : 0x00);
        return this;
    }
    /**
     * Write `value` as an 8-bit signed integer and move pointer forward by 1 byte.
     * @param value - The value to write.
     * @returns This.
     */ writeInt8(value) {
        this.ensureAvailable(1);
        this._data.setInt8(this.offset++, value);
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as an 8-bit unsigned integer and move pointer forward by 1
     * byte.
     * @param value - The value to write.
     * @returns This.
     */ writeUint8(value) {
        this.ensureAvailable(1);
        this._data.setUint8(this.offset++, value);
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * An alias for {@link IOBuffer#writeUint8}.
     * @param value - The value to write.
     * @returns This.
     */ writeByte(value) {
        return this.writeUint8(value);
    }
    /**
     * Write all elements of `bytes` as uint8 values and move pointer forward by
     * `bytes.length` bytes.
     * @param bytes - The array of bytes to write.
     * @returns This.
     */ writeBytes(bytes) {
        this.ensureAvailable(bytes.length);
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < bytes.length; i++)this._data.setUint8(this.offset++, bytes[i]);
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 16-bit signed integer and move pointer forward by 2
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeInt16(value) {
        this.ensureAvailable(2);
        this._data.setInt16(this.offset, value, this.littleEndian);
        this.offset += 2;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 16-bit unsigned integer and move pointer forward by 2
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeUint16(value) {
        this.ensureAvailable(2);
        this._data.setUint16(this.offset, value, this.littleEndian);
        this.offset += 2;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 32-bit signed integer and move pointer forward by 4
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeInt32(value) {
        this.ensureAvailable(4);
        this._data.setInt32(this.offset, value, this.littleEndian);
        this.offset += 4;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 32-bit unsigned integer and move pointer forward by 4
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeUint32(value) {
        this.ensureAvailable(4);
        this._data.setUint32(this.offset, value, this.littleEndian);
        this.offset += 4;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 32-bit floating number and move pointer forward by 4
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeFloat32(value) {
        this.ensureAvailable(4);
        this._data.setFloat32(this.offset, value, this.littleEndian);
        this.offset += 4;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 64-bit floating number and move pointer forward by 8
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeFloat64(value) {
        this.ensureAvailable(8);
        this._data.setFloat64(this.offset, value, this.littleEndian);
        this.offset += 8;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 64-bit signed bigint and move pointer forward by 8
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeBigInt64(value) {
        this.ensureAvailable(8);
        this._data.setBigInt64(this.offset, value, this.littleEndian);
        this.offset += 8;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 64-bit unsigned bigint and move pointer forward by 8
     * bytes.
     * @param value - The value to write.
     * @returns This.
     */ writeBigUint64(value) {
        this.ensureAvailable(8);
        this._data.setBigUint64(this.offset, value, this.littleEndian);
        this.offset += 8;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write the charCode of `str`'s first character as an 8-bit unsigned integer
     * and move pointer forward by 1 byte.
     * @param str - The character to write.
     * @returns This.
     */ writeChar(str) {
        // eslint-disable-next-line unicorn/prefer-code-point
        return this.writeUint8(str.charCodeAt(0));
    }
    /**
     * Write the charCodes of all `str`'s characters as 8-bit unsigned integers
     * and move pointer forward by `str.length` bytes.
     * @param str - The characters to write.
     * @returns This.
     */ writeChars(str) {
        for(let i = 0; i < str.length; i++)// eslint-disable-next-line unicorn/prefer-code-point
        this.writeUint8(str.charCodeAt(i));
        return this;
    }
    /**
     * UTF-8 encode and write `str` to the current pointer offset and move pointer
     * forward according to the encoded length.
     * @param str - The string to write.
     * @returns This.
     */ writeUtf8(str) {
        return this.writeBytes((0, $956dd9b222f51e03$export$c564cdbbe6da493)(str));
    }
    /**
     * Export a Uint8Array view of the internal buffer.
     * The view starts at the byte offset and its length
     * is calculated to stop at the last written byte or the original length.
     * @returns A new Uint8Array view.
     */ toArray() {
        return new Uint8Array(this.buffer, this.byteOffset, this.lastWrittenByte);
    }
    /**
     *  Get the total number of bytes written so far, regardless of the current offset.
     * @returns - Total number of bytes.
     */ getWrittenByteLength() {
        return this.lastWrittenByte - this.byteOffset;
    }
    /**
     * Update the last written byte offset
     * @private
     */ _updateLastWrittenByte() {
        if (this.offset > this.lastWrittenByte) this.lastWrittenByte = this.offset;
    }
}


class $391dde8a9057c296$export$2e2bcd8739ae039 {
    bufferData;
    pixelDataOffset;
    width;
    height;
    bitsPerPixel;
    xPixelsPerMeter;
    yPixelsPerMeter;
    compression;
    colorMasks;
    constructor(bufferData){
        this.bufferData = new (0, $1a3e0bc2b2fb1c0c$export$6b4c32f3d5b8738a)(bufferData);
        const formatCheck = this.bufferData.readBytes(2);
        if (formatCheck[0] !== 0x42 && formatCheck[1] !== 0x4d) throw new Error('This is not a BMP image or the encoding is not correct.');
        this.pixelDataOffset = this.bufferData.skip(8).readUint32();
        this.width = this.bufferData.skip(4).readUint32();
        this.height = this.bufferData.readUint32();
        this.bitsPerPixel = this.bufferData.seek(28).readUint16();
        if (this.bitsPerPixel !== 1 && this.bitsPerPixel !== 8 && this.bitsPerPixel !== 24 && this.bitsPerPixel !== 32) throw new Error(`Invalid number of bits per pixel. Supported number of bits per pixel: 1, 8, 24, 32. Received: ${this.bitsPerPixel}`);
        this.compression = this.bufferData.readUint32();
        if (this.compression !== 0 && this.compression !== 3) throw new Error(`Only BI_RGB and BI_BITFIELDS compression methods are allowed. `);
        this.colorMasks = [
            this.bufferData.seek(54).readUint32(),
            this.bufferData.readUint32(),
            this.bufferData.readUint32()
        ];
        if (this.bitsPerPixel === 32 && (this.colorMasks[0] !== 0x00ff0000 || this.colorMasks[1] !== 0x0000ff00 || this.colorMasks[2] !== 0x000000ff)) throw new Error(`Unsupported color masks detected in 32-bit BMP image. Only standard RGBA (${0x00ff0000.toString(16)}, ${0x0000ff00.toString(16)}, ${0x000000ff.toString(16)}) masks are supported. Received: ${this.colorMasks[0].toString(16)},${this.colorMasks[1].toString(16)},${this.colorMasks[2].toString(16)}.`);
        this.bufferData.skip(1); // skipping image size.
        this.xPixelsPerMeter = this.bufferData.seek(38).readInt32();
        this.yPixelsPerMeter = this.bufferData.readInt32();
        this.bufferData.skip(1);
    }
    decode() {
        this.bufferData.seek(this.pixelDataOffset);
        this.bufferData.setBigEndian();
        const channels = Math.ceil(this.bitsPerPixel / 8);
        const components = channels % 2 === 0 ? channels - 1 : channels;
        const data = this.decodePixelData(channels, components);
        return {
            width: this.width,
            height: this.height,
            bitsPerPixel: this.bitsPerPixel,
            compression: this.compression,
            colorMasks: this.colorMasks,
            channels: channels,
            components: components,
            data: data,
            yPixelsPerMeter: this.yPixelsPerMeter,
            xPixelsPerMeter: this.xPixelsPerMeter
        };
    }
    decodePixelData(channels, components) {
        const data = new Uint8Array(this.height * this.width * channels);
        if (this.bitsPerPixel === 1) this.decodeBitDepth1Pixels(data);
        else if (channels === components) this.decodeStandardPixels(data, channels);
        else this.decodePixelsWithAlpha(data, channels, components);
        return data;
    }
    decodeBitDepth1Pixels(data) {
        let currentNumber = 0;
        for(let row = 0; row < this.height; row++)for(let col = 0; col < this.width; col++){
            const bitIndex = col % 32;
            if (bitIndex === 0) currentNumber = this.bufferData.readUint32();
            if (currentNumber & 1 << 31 - bitIndex) data[(this.height - row - 1) * this.width + col] = 1;
        }
    }
    decodeStandardPixels(data, channels) {
        const padding = this.calculatePadding(channels);
        for(let row = 0; row < this.height; row++){
            const rowOffset = (this.height - row - 1) * this.width;
            for(let col = 0; col < this.width; col++)for(let channel = channels - 1; channel >= 0; channel--)data[(rowOffset + col) * channels + channel] = this.bufferData.readByte();
            this.bufferData.skip(padding);
        }
    }
    decodePixelsWithAlpha(data, channels, components) {
        for(let row = 0; row < this.height; row++){
            const rowOffset = (this.height - row - 1) * this.width;
            for(let col = 0; col < this.width; col++){
                const pixelBaseIndex = (rowOffset + col) * channels;
                // Decode color components
                for(let component = components - 1; component >= 0; component--)data[pixelBaseIndex + component] = this.bufferData.readByte();
                // Decode alpha channel
                data[pixelBaseIndex + components] = this.bufferData.readByte();
            }
        }
    }
    calculatePadding(channels) {
        return this.width * channels % 4 === 0 ? 0 : 4 - this.width * channels % 4;
    }
}



const $6e31370d4722661b$export$2414787a87bf10d1 = {
    LogicalColorSpace: {
        // https://msdn.microsoft.com/en-us/library/cc250396.aspx
        LCS_CALIBRATED_RGB: 0x00000000,
        LCS_sRGB: 0x73524742,
        LCS_WINDOWS_COLOR_SPACE: 0x57696e20
    },
    Compression: {
        // https://msdn.microsoft.com/en-us/library/cc250415.aspx
        BI_RGB: 0x0000,
        BI_RLE8: 0x0001,
        BI_RLE4: 0x0002,
        BI_BITFIELDS: 0x0003,
        BI_JPEG: 0x0004,
        BI_PNG: 0x0005,
        BI_CMYK: 0x000b,
        BI_CMYKRLE8: 0x000c,
        BI_CMYKRLE4: 0x000d
    },
    GamutMappingIntent: {
        // https://msdn.microsoft.com/en-us/library/cc250392.aspx
        LCS_GM_ABS_COLORIMETRIC: 0x00000008,
        LCS_GM_BUSINESS: 0x00000001,
        LCS_GM_GRAPHICS: 0x00000002,
        LCS_GM_IMAGES: 0x00000004
    },
    // legacy resolution (72 dpi)
    DEFAULT_PIXELS_PER_METER: 2835
};


class $2a8433227620e4c7$export$2e2bcd8739ae039 {
    width;
    height;
    bitsPerPixel;
    channels;
    components;
    data;
    xPixelsPerMeter;
    yPixelsPerMeter;
    encoded = new (0, $1a3e0bc2b2fb1c0c$export$6b4c32f3d5b8738a)();
    compression;
    colorMasks;
    constructor(data){
        if (!data.height || !data.width) throw new Error('ImageData width and height are required.');
        this.data = data.data;
        this.width = data.width;
        this.height = data.height;
        if (this.data.length !== data.width * data.height * data.channels) throw new Error('Invalid data length.');
        this.bitsPerPixel = data.bitsPerPixel;
        if (this.bitsPerPixel !== 1 && this.bitsPerPixel !== 8 && this.bitsPerPixel !== 24 && this.bitsPerPixel !== 32) throw new Error(`Invalid number of bits per pixel. Supported number of bits per pixel: 1, 8, 24, 32. Received: ${this.bitsPerPixel}`);
        this.channels = data.channels;
        this.components = this.channels % 2 === 0 ? this.channels - 1 : this.channels;
        this.xPixelsPerMeter = data.xPixelsPerMeter ?? (0, $6e31370d4722661b$export$2414787a87bf10d1).DEFAULT_PIXELS_PER_METER;
        this.yPixelsPerMeter = data.yPixelsPerMeter ?? (0, $6e31370d4722661b$export$2414787a87bf10d1).DEFAULT_PIXELS_PER_METER;
        this.compression = data.compression ?? 0;
        this.colorMasks = data.colorMasks ?? [
            0x00ff0000,
            0x0000ff00,
            0x000000ff
        ];
    }
    encode() {
        this.encoded = new (0, $1a3e0bc2b2fb1c0c$export$6b4c32f3d5b8738a)();
        this.encoded.skip(14);
        this.writeBitmapV5Header();
        if (this.bitsPerPixel <= 8) this.writeColorTable();
        const offset = this.encoded.offset;
        this.writePixelArray();
        const imageSize = this.encoded.getWrittenByteLength();
        this.encoded.rewind();
        this.writeBitmapFileHeader(offset, imageSize);
        return this.encoded.toArray();
    }
    writePixelArray() {
        this.encoded.setBigEndian();
        if (this.bitsPerPixel === 1) this.writeBitDepth1Pixels();
        else if (this.channels === this.components) this.writeStandardPixels();
        else this.writePixelsWithAlpha();
        this.encoded.setLittleEndian();
    }
    writeBitDepth1Pixels() {
        let byte = 0;
        for(let row = this.height - 1; row >= 0; row--){
            for(let col = 0; col < this.width; col++){
                if (col % 32 === 0 && col !== 0) {
                    this.encoded.writeUint32(byte);
                    byte = 0;
                }
                byte |= this.data[row * this.width + col] << 31 - col % 32;
            }
            this.encoded.writeUint32(byte);
            byte = 0;
        }
    }
    writeStandardPixels() {
        for(let row = 0; row < this.height; row++){
            const rowOffset = this.width * (this.height - row - 1) * this.channels;
            for(let col = 0; col < this.width; col++)for(let channel = this.channels - 1; channel >= 0; channel--)this.encoded.writeByte(this.data[rowOffset + col * this.channels + channel]);
            this.writePadding();
        }
    }
    writePixelsWithAlpha() {
        const pixel = 0;
        for(let row = 0; row < this.height; row++){
            const rowOffset = this.width * (this.height - row - 1);
            for(let col = 0; col < this.width; col++){
                const pixelIndex = (rowOffset + col) * this.channels;
                this.encoded.writeUint32(pixel | this.data[pixelIndex + 2] << 24 | this.data[pixelIndex + 1] << 16 | this.data[pixelIndex] << 8 | this.data[pixelIndex + 3]);
            }
        }
    }
    writePadding() {
        const padding = this.width * this.channels % 4 === 0 ? 0 : 4 - this.width * this.channels % 4;
        for(let i = 0; i < padding; i++)this.encoded.writeByte(0);
    }
    writeColorTable() {
        if (this.bitsPerPixel === 1) this.encoded.writeUint32(0x00000000) // black
        .writeUint32(0x00ffffff); // white
        else //Grayscale 8 bit
        for(let i = 0; i < 256; i++)this.encoded.writeUint32(0x00000000 | i << 16 | i << 8 | i);
    }
    writeBitmapFileHeader(imageOffset, fileSize) {
        this.encoded.writeChars('BM') // 14 bytes bitmap file header
        .writeInt32(fileSize) // Size of BMP file in bytes
        .writeUint16(0).writeUint16(0).writeUint32(imageOffset);
    }
    writeBitmapV5Header() {
        const rowSize = Math.floor((this.bitsPerPixel * this.width + 31) / 32) * 4;
        const totalBytes = rowSize * this.height;
        // Size of the header
        this.encoded.writeUint32(124) // Header size, offset 14
        .writeInt32(this.width) // bV5Width, offset 18
        .writeInt32(this.height) // bV5Height, offset 22
        .writeUint16(1) // bv5Planes - must be set to 1, offset 26
        .writeUint16(this.bitsPerPixel) // bV5BitCount, offset 30
        .writeUint32(this.compression) // bV5Compression - No compression, offset 34
        .writeUint32(totalBytes) // bv5SizeImage - size of pixel buffer (can be 0 if uncompressed), offset 38
        .writeInt32(this.xPixelsPerMeter) // bV5XPelsPerMeter - resolution, offset 42
        .writeInt32(this.yPixelsPerMeter) // bV5YPelsPerMeter - resolution, offset 46
        .writeUint32(this.bitsPerPixel <= 8 ? 2 ** this.bitsPerPixel : 0) // number of colors used, set to 0 if number of pixels is bigger than 8 set to 0, offset 50
        .writeUint32(this.bitsPerPixel <= 8 ? 2 ** this.bitsPerPixel : 0); // number of important colors, set to 0 if number of pixels is bigger than 8 set to 0,  offset 54
        if (this.bitsPerPixel === 32 && (this.colorMasks[0] !== 0x00ff0000 || this.colorMasks[1] !== 0x0000ff00 || this.colorMasks[2] !== 0x000000ff)) throw new Error(`Unsupported color masks detected in 32-bit BMP image. Only standard RGBA (${0x00ff0000.toString(16)}, ${0x0000ff00.toString(16)}, ${0x000000ff.toString(16)}) masks are supported. Received: ${this.colorMasks[0].toString(16)},${this.colorMasks[1].toString(16)},${this.colorMasks[2].toString(16)}.`);
        this.encoded.writeUint32(this.colorMasks[0]) // bV5RedMask, offset 58
        .writeUint32(this.colorMasks[1]) // bV5GreenMask, offset 62
        .writeUint32(this.colorMasks[2]) // bV5BlueMask, offset 66
        .writeUint32(this.channels === this.components ? 0x00000000 : 0xff000000) // bv5ReservedData
        .writeUint32((0, $6e31370d4722661b$export$2414787a87bf10d1).LogicalColorSpace.LCS_sRGB).skip(36) // bV5Endpoints
        .skip(12) // bV5GammaRed, Green, Blue
        .writeUint32((0, $6e31370d4722661b$export$2414787a87bf10d1).GamutMappingIntent.LCS_GM_GRAPHICS).skip(12); // ProfileData, ProfileSize, Reserved
    }
}


function $bf90d8d77747d24f$export$c564cdbbe6da493(data) {
    const encoder = new (0, $2a8433227620e4c7$export$2e2bcd8739ae039)(data);
    return encoder.encode();
}
function $bf90d8d77747d24f$export$2f872c0f2117be69(data) {
    const decoder = new (0, $391dde8a9057c296$export$2e2bcd8739ae039)(data);
    return decoder.decode();
}



const $758b13dad9bc33fb$export$cf629b29f6b8313d = (layer)=>{
    const data = [];
    for (const pixel of layer.pixels)data.push(...(0, $1e0e3a956a824c28$export$6d1b0a04fee90d44).toRGB(pixel));
    const encoded = (0, $bf90d8d77747d24f$export$c564cdbbe6da493)({
        width: layer.x,
        height: layer.y,
        bitsPerPixel: 24,
        compression: 0,
        colorMasks: [],
        components: 1,
        channels: 3,
        data: new Uint8Array(data)
    });
    return encoded;
};


/*
eslint-disable no-restricted-imports
*/ 


const $260fd5f095c9ff57$export$647a018e726c9725 = (back, front, { offset: offset = (0, $8eba8339316108f6$export$912a92c4dfa79ecb) } = {})=>{
    const pixels = back.pixels;
    for(let index = 0; index < front.x * front.y; index = index + 1){
        const coords = (0, $8eba8339316108f6$export$94c12620b65d3208)(index, front);
        const frontPixelColor = (0, $8eba8339316108f6$export$5551a2d24ff40153)(coords, front);
        const backPixelIndex = (0, $8eba8339316108f6$export$cf0d5f39e99a45f1)({
            x: coords.x + offset.x,
            y: coords.y + offset.y
        }, back);
        pixels[backPixelIndex] = frontPixelColor;
    }
};
const $260fd5f095c9ff57$export$aa05ae6907f2a9a3 = (back, front, { offset: offset = (0, $8eba8339316108f6$export$912a92c4dfa79ecb) } = {})=>{
    const pixels = [
        ...back.pixels
    ];
    for(let index = 0; index < front.x * front.y; index = index + 1){
        const coords = (0, $8eba8339316108f6$export$94c12620b65d3208)(index, front);
        const coordsAtBack = {
            x: coords.x + offset.x,
            y: coords.y + offset.y
        };
        const frontPixelColor = (0, $8eba8339316108f6$export$5551a2d24ff40153)(coords, front);
        const backPixelColor = (0, $8eba8339316108f6$export$5551a2d24ff40153)(coordsAtBack, back);
        if (backPixelColor === null) continue;
        const backPixelIndex = (0, $8eba8339316108f6$export$cf0d5f39e99a45f1)(coordsAtBack, back);
        const newColor = (0, $3c901d31e89c6ceb$export$33ee99e9ec522cbf)(frontPixelColor, backPixelColor);
        pixels[backPixelIndex] = newColor;
    }
    return {
        ...back,
        pixels: pixels
    };
};
const $260fd5f095c9ff57$export$dbfe51fe6a130736 = (...args)=>{
    const flippedArgs = args.reverse();
    const first = flippedArgs.shift();
    if (first == null) {
        console.warn(`You tried to overlay 0 layers wtf`);
        return (0, $5f1f5d71b8f7bfcb$export$b88056449f3c8af9).blankWithAlpha((0, $8eba8339316108f6$export$912a92c4dfa79ecb));
    }
    let [canvas, canvasParams] = first;
    if (canvasParams != null) console.warn(`Your initial canvas had layer transform parameters.` + `\n` + `If you want to do that, place that` + `layer it on top of a blank non-transformed layer`);
    for (const arg of args)canvas = $260fd5f095c9ff57$export$aa05ae6907f2a9a3(canvas, arg[0], arg[1]);
    return canvas;
};



const $f5ce12c59aecc6e8$export$ca81a01f96d956e9 = (size, brushFn = (0, $1e0e3a956a824c28$export$da5d6544e8c27bc1).solidFill((0, $3c901d31e89c6ceb$export$b2b4e19872dae74).BLACK))=>{
    const pixels = [];
    const meta = {
        ...size,
        id: Math.random(),
        __isLayer: true
    };
    for(let index = 0; index < size.x * size.y; index = index + 1)pixels.push(brushFn(index, meta));
    return {
        ...meta,
        pixels: pixels
    };
};
const $f5ce12c59aecc6e8$export$5eb17455ce344cf5 = (coords)=>$f5ce12c59aecc6e8$export$ca81a01f96d956e9(coords, (0, $1e0e3a956a824c28$export$da5d6544e8c27bc1).alphaSolidFill());





const $b1465787bdab3344$export$198d77cf2f7b811b = (image)=>{
    const pixels = [];
    for(let i = 0; i < [
        ...image.data
    ].length; i += image.channels){
        if (image.channels === 4 && image.data[i] === 0) {
            pixels.push((0, $3c901d31e89c6ceb$export$b2b4e19872dae74).ALPHA);
            continue;
        }
        pixels.push((0, $1e0e3a956a824c28$export$6d1b0a04fee90d44).fromRGB(image.data[i], image.data[i + 1], image.data[i + 2]));
    }
    return {
        __isLayer: true,
        id: Math.random(),
        x: image.width,
        y: image.height,
        pixels: pixels
    };
};
const $b1465787bdab3344$export$eda4a19ea478c3be = (image, fgBrush = (0, $1e0e3a956a824c28$export$da5d6544e8c27bc1).solidFill((0, $3c901d31e89c6ceb$export$b2b4e19872dae74).BLACK), bgBrush = (0, $1e0e3a956a824c28$export$da5d6544e8c27bc1).alphaSolidFill())=>{
    return (0, $5f1f5d71b8f7bfcb$export$b88056449f3c8af9).blank({
        x: Math.floor(image.width),
        y: Math.floor(image.height)
    }, (index, meta)=>{
        return image.data[index] ? fgBrush(index, meta) : bgBrush(index, meta);
    });
};


const $8c3f74b3bf1b7e96$export$9c5ad6d66a264a8b = (buffer)=>{
    const imageData = (0, $bf90d8d77747d24f$export$2f872c0f2117be69)(buffer);
    if (imageData.bitsPerPixel === 1) {
        console.warn(`Inflating 1bit image to 24. Will use default colors in importSingleChannelImage`);
        return (0, $b1465787bdab3344$export$eda4a19ea478c3be)({
            ...imageData,
            // @ts-expect-error this array sucks
            data: [
                ...imageData.data
            ]
        });
    }
    if (imageData.bitsPerPixel === 24) return (0, $b1465787bdab3344$export$198d77cf2f7b811b)({
        ...imageData,
        data: [
            ...imageData.data
        ]
    });
    if (imageData.bitsPerPixel === 32) {
        console.warn(`Deflating 32bit image to 24bit. Alpha will be guessed (did u know bmps have alpha??)`);
        return (0, $b1465787bdab3344$export$198d77cf2f7b811b)({
            ...imageData,
            data: [
                ...imageData.data
            ]
        });
    }
    throw new Error(`Unsupported image type (${imageData.bitsPerPixel}bpp), try using fast-bmp alone to get a 1/24/32 bit buffer`);
};





const $98c4b006373ae38c$export$2102481a927fc831 = (text, font, brushFn = (0, $1e0e3a956a824c28$export$da5d6544e8c27bc1).solidFill((0, $3c901d31e89c6ceb$export$b2b4e19872dae74).BLACK), { letterPlateBrush: letterPlateBrush = (0, $1e0e3a956a824c28$export$da5d6544e8c27bc1).alphaSolidFill(), maxLengthPx: maxLengthPx = Infinity, minLengthPx: minLengthPx = 0, breakLinesOn: breakLinesOn = ` ` } = {})=>{
    const { getCharacter: getCharacter } = font;
    const lineHeight = getCharacter(`X`).height;
    const charLayers = [];
    const words = text.split(breakLinesOn).map((word, idx, arr)=>arr.length === idx + 1 ? word : word + breakLinesOn).map((word)=>word.split(`\n`).map((word, idx, arr)=>arr.length === idx + 1 ? word : [
                word,
                `\n`
            ])).flat(2);
    let lineOffset = 0;
    let maxWidth = 0;
    let lines = 1;
    for (const word of words){
        const newline = ()=>{
            maxWidth = Math.max(lineOffset, maxWidth);
            lineOffset = 0;
            lines++;
        };
        const wordLayers = [];
        let wordOffset = 0;
        for (const character of word){
            if (character === `\n`) {
                newline();
                continue;
            }
            const char = (0, $b1465787bdab3344$export$eda4a19ea478c3be)(getCharacter(character), brushFn, letterPlateBrush);
            wordLayers.push([
                char,
                wordOffset
            ]);
            wordOffset += char.x;
        }
        if (lineOffset + wordOffset > maxLengthPx) newline();
        charLayers.push(...wordLayers.map((layer)=>[
                layer[0],
                {
                    offset: {
                        x: lineOffset + layer[1],
                        y: lineHeight * (lines - 1)
                    }
                }
            ]));
        lineOffset = lineOffset + wordOffset;
    }
    const textLayer = (0, $5f1f5d71b8f7bfcb$export$b88056449f3c8af9).blankWithAlpha({
        x: Math.max(minLengthPx, Math.max(lineOffset, maxWidth)),
        y: lineHeight * lines
    });
    for (const layer of charLayers)(0, $5f1f5d71b8f7bfcb$export$b724cf1b0ea821f5).punch(textLayer, layer[0], layer[1]);
    return textLayer;
};






const $46c21443bfd675a7$export$c886ee4c51c28a9f = (source, { x: scaleX, y: scaleY })=>{
    return (0, $5f1f5d71b8f7bfcb$export$b88056449f3c8af9).blank({
        x: ~~(source.x * scaleX),
        y: ~~(source.y * scaleY)
    }, (index, meta)=>{
        const coords = (0, $8eba8339316108f6$export$94c12620b65d3208)(index, meta);
        const maybeTargetPixel = (0, $8eba8339316108f6$export$5551a2d24ff40153)({
            x: ~~(coords.x / scaleX),
            y: ~~(coords.y / scaleY)
        }, source);
        return maybeTargetPixel ?? (0, $3c901d31e89c6ceb$export$b2b4e19872dae74).ALPHA;
    });
};
const $46c21443bfd675a7$export$bbc22ac96d54269b = (layer, painterFn)=>{
    const pixels = [];
    for(let index = 0; index < layer.x * layer.y; index = index + 1){
        const newColor = painterFn(layer.pixels[index])(index, layer);
        pixels.push(newColor);
    }
    return {
        ...layer,
        pixels: pixels
    };
};
const $46c21443bfd675a7$export$ff2a79d1bd86a94c = (source, offset)=>{
    const target = (0, $5f1f5d71b8f7bfcb$export$b88056449f3c8af9).blankWithAlpha({
        x: source.x + offset.x * 2,
        y: source.y + offset.y * 2
    });
    (0, $5f1f5d71b8f7bfcb$export$b724cf1b0ea821f5).punch(target, source, {
        offset: offset
    });
    return target;
};
const $46c21443bfd675a7$export$7ce33da42d634fb6 = (source, bgBrush = (0, $1e0e3a956a824c28$export$da5d6544e8c27bc1).solidFill(0xff00ff))=>(0, $5f1f5d71b8f7bfcb$export$b724cf1b0ea821f5).overlay((0, $5f1f5d71b8f7bfcb$export$b88056449f3c8af9).blank(source, bgBrush), source);
const $46c21443bfd675a7$export$a57ab32f40f83ea9 = (stackAxis)=>(sources, gap = 0)=>{
        const counterAxis = stackAxis === 'x' ? 'y' : 'x';
        const stackAxisLength = sources.reduce((a, b, c)=>{
            // add them up
            return a + (c === sources.length - 1 ? b[stackAxis] : b[stackAxis] + gap);
        }, 0);
        const counterAxisLength = Math.max(...sources.map((s)=>s[counterAxis]));
        const bg = (0, $5f1f5d71b8f7bfcb$export$b88056449f3c8af9).blankWithAlpha({
            [counterAxis]: counterAxisLength,
            [stackAxis]: stackAxisLength
        });
        let spacing = 0;
        for (const source of sources){
            (0, $5f1f5d71b8f7bfcb$export$b724cf1b0ea821f5).punch(bg, source, {
                offset: {
                    [counterAxis]: 0,
                    [stackAxis]: spacing
                }
            });
            spacing += source[stackAxis] + gap;
        }
        return bg;
    };
const $46c21443bfd675a7$export$bb628a54ab399bc9 = (source, tilt)=>{
    switch(tilt){
        case 90:
            return (0, $5f1f5d71b8f7bfcb$export$b88056449f3c8af9).blank({
                x: source.y,
                y: source.x
            }, (index, layer)=>{
                const currentCoords = (0, $a5ee77bd64375024$export$cdddc5dc0b5a25e4)(index, layer);
                return (0, $a5ee77bd64375024$export$7ee2609c9d01f742)({
                    x: layer.y - 1 - currentCoords.y,
                    y: layer.x - 1 - currentCoords.x
                }, source);
            });
        case 180:
            return (0, $5f1f5d71b8f7bfcb$export$b88056449f3c8af9).blank(source, (index, layer)=>{
                const currentCoords = (0, $a5ee77bd64375024$export$cdddc5dc0b5a25e4)(index, layer);
                return (0, $a5ee77bd64375024$export$7ee2609c9d01f742)({
                    y: layer.y - 1 - currentCoords.y,
                    x: layer.x - 1 - currentCoords.x
                }, source);
            });
        case 270:
            return (0, $5f1f5d71b8f7bfcb$export$b88056449f3c8af9).blank({
                x: source.y,
                y: source.x
            }, (index, layer)=>{
                const currentCoords = (0, $a5ee77bd64375024$export$cdddc5dc0b5a25e4)(index, layer);
                return (0, $a5ee77bd64375024$export$7ee2609c9d01f742)({
                    x: currentCoords.y,
                    y: currentCoords.x
                }, source);
            });
        default:
            return source;
    }
};
const $46c21443bfd675a7$export$5bec46363e03b680 = (source, newDimensions, { offset: offset = (0, $8eba8339316108f6$export$912a92c4dfa79ecb) } = {})=>{
    return (0, $5f1f5d71b8f7bfcb$export$b88056449f3c8af9).blank(newDimensions, (index, target)=>{
        const coords = (0, $8eba8339316108f6$export$94c12620b65d3208)(index, target);
        const colorFromSource = (0, $a5ee77bd64375024$export$7ee2609c9d01f742)({
            x: coords.x - offset.x,
            y: coords.y - offset.y
        }, source);
        return colorFromSource ?? (0, $3c901d31e89c6ceb$export$b2b4e19872dae74).ALPHA;
    });
};


const $5f1f5d71b8f7bfcb$export$b88056449f3c8af9 = {
    /**
  This makes a basic layer with any fill brush. Great base canvas
  */ blank: (0, $f5ce12c59aecc6e8$export$ca81a01f96d956e9),
    /**
  This makes a blank layer thats transparent in one shot
  */ blankWithAlpha: (0, $f5ce12c59aecc6e8$export$5eb17455ce344cf5),
    /**
  Loads up a bmp file as a layer, only some 
  bits are supported! but anything from mspaint should be fine
  */ image: (0, $8c3f74b3bf1b7e96$export$9c5ad6d66a264a8b),
    /**
   * Writes text on a layer
   */ text: (0, $98c4b006373ae38c$export$2102481a927fc831)
};
const $5f1f5d71b8f7bfcb$export$abb141da9ad8bea6 = {
    /**
  Applies what i think is a nearest-neighbor transform 
  to the layer. only integer transforms _really_ work 
  for precise results but you can get some cool effects with floats
  */ scale: (0, $46c21443bfd675a7$export$c886ee4c51c28a9f),
    /**
  Loop over layer pixels to paint them in a different way
  */ paint: (0, $46c21443bfd675a7$export$bbc22ac96d54269b),
    /**
  Remove extra pixels for the bleeding edges of the layer
  */ crop: (0, $46c21443bfd675a7$export$5bec46363e03b680),
    rotate: /**
  Rotate in quarter steps
  */ $46c21443bfd675a7$export$bb628a54ab399bc9,
    /**
  Stack several layers without overlap, great for layouts and stuff
  */ stackHorizontal: (0, $46c21443bfd675a7$export$a57ab32f40f83ea9)('x'),
    /**
  Stack several layers without overlap, great for layouts and stuff
  */ stackVertical: (0, $46c21443bfd675a7$export$a57ab32f40f83ea9)('y'),
    /**
  Adds a padding to all four sides of any layer in a
  transparent background, you can composite this layer
  with addBackgroundToLayer
  */ pad: (0, $46c21443bfd675a7$export$ff2a79d1bd86a94c),
    /**
    Puts a background color under a transparent layer,
    great for using with padLayer
  */ setBackground: (0, $46c21443bfd675a7$export$7ce33da42d634fb6)
};
const $5f1f5d71b8f7bfcb$export$b724cf1b0ea821f5 = {
    /*
  OVERRIDES SOURCE!!

  Fast but destructive. No blend modes, no checks,
  super useful if painting over canvases tho.
  
  OVERRIDES SOURCE!!
  */ punch: (0, $260fd5f095c9ff57$export$647a018e726c9725),
    /*
  Overlay a layer over another, apply an offset
  and maybe eventually a blend mode??
  */ overlay: (0, $260fd5f095c9ff57$export$aa05ae6907f2a9a3),
    /**
  Join a bunch of layers.
  
  Note that this is reversed (front to back) so
  it matches how most layers work in software.
  its confusing if you think about it but makes sense if you do
  */ overlayStack: (0, $260fd5f095c9ff57$export$dbfe51fe6a130736)
};



/*
eslint-disable no-restricted-imports
*/ var $eca075ad100d834d$exports = {};
"use strict";


var $66e1b8c3059c3a3e$exports = {};
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $0185bf00fa9bfdb8$exports = {};
// shim for using process in browser
var $0185bf00fa9bfdb8$var$process = $0185bf00fa9bfdb8$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $0185bf00fa9bfdb8$var$cachedSetTimeout;
var $0185bf00fa9bfdb8$var$cachedClearTimeout;
function $0185bf00fa9bfdb8$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $0185bf00fa9bfdb8$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $0185bf00fa9bfdb8$var$cachedSetTimeout = setTimeout;
        else $0185bf00fa9bfdb8$var$cachedSetTimeout = $0185bf00fa9bfdb8$var$defaultSetTimout;
    } catch (e) {
        $0185bf00fa9bfdb8$var$cachedSetTimeout = $0185bf00fa9bfdb8$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $0185bf00fa9bfdb8$var$cachedClearTimeout = clearTimeout;
        else $0185bf00fa9bfdb8$var$cachedClearTimeout = $0185bf00fa9bfdb8$var$defaultClearTimeout;
    } catch (e) {
        $0185bf00fa9bfdb8$var$cachedClearTimeout = $0185bf00fa9bfdb8$var$defaultClearTimeout;
    }
})();
function $0185bf00fa9bfdb8$var$runTimeout(fun) {
    if ($0185bf00fa9bfdb8$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($0185bf00fa9bfdb8$var$cachedSetTimeout === $0185bf00fa9bfdb8$var$defaultSetTimout || !$0185bf00fa9bfdb8$var$cachedSetTimeout) && setTimeout) {
        $0185bf00fa9bfdb8$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $0185bf00fa9bfdb8$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $0185bf00fa9bfdb8$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $0185bf00fa9bfdb8$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $0185bf00fa9bfdb8$var$runClearTimeout(marker) {
    if ($0185bf00fa9bfdb8$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($0185bf00fa9bfdb8$var$cachedClearTimeout === $0185bf00fa9bfdb8$var$defaultClearTimeout || !$0185bf00fa9bfdb8$var$cachedClearTimeout) && clearTimeout) {
        $0185bf00fa9bfdb8$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $0185bf00fa9bfdb8$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $0185bf00fa9bfdb8$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $0185bf00fa9bfdb8$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $0185bf00fa9bfdb8$var$queue = [];
var $0185bf00fa9bfdb8$var$draining = false;
var $0185bf00fa9bfdb8$var$currentQueue;
var $0185bf00fa9bfdb8$var$queueIndex = -1;
function $0185bf00fa9bfdb8$var$cleanUpNextTick() {
    if (!$0185bf00fa9bfdb8$var$draining || !$0185bf00fa9bfdb8$var$currentQueue) return;
    $0185bf00fa9bfdb8$var$draining = false;
    if ($0185bf00fa9bfdb8$var$currentQueue.length) $0185bf00fa9bfdb8$var$queue = $0185bf00fa9bfdb8$var$currentQueue.concat($0185bf00fa9bfdb8$var$queue);
    else $0185bf00fa9bfdb8$var$queueIndex = -1;
    if ($0185bf00fa9bfdb8$var$queue.length) $0185bf00fa9bfdb8$var$drainQueue();
}
function $0185bf00fa9bfdb8$var$drainQueue() {
    if ($0185bf00fa9bfdb8$var$draining) return;
    var timeout = $0185bf00fa9bfdb8$var$runTimeout($0185bf00fa9bfdb8$var$cleanUpNextTick);
    $0185bf00fa9bfdb8$var$draining = true;
    var len = $0185bf00fa9bfdb8$var$queue.length;
    while(len){
        $0185bf00fa9bfdb8$var$currentQueue = $0185bf00fa9bfdb8$var$queue;
        $0185bf00fa9bfdb8$var$queue = [];
        while(++$0185bf00fa9bfdb8$var$queueIndex < len)if ($0185bf00fa9bfdb8$var$currentQueue) $0185bf00fa9bfdb8$var$currentQueue[$0185bf00fa9bfdb8$var$queueIndex].run();
        $0185bf00fa9bfdb8$var$queueIndex = -1;
        len = $0185bf00fa9bfdb8$var$queue.length;
    }
    $0185bf00fa9bfdb8$var$currentQueue = null;
    $0185bf00fa9bfdb8$var$draining = false;
    $0185bf00fa9bfdb8$var$runClearTimeout(timeout);
}
$0185bf00fa9bfdb8$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $0185bf00fa9bfdb8$var$queue.push(new $0185bf00fa9bfdb8$var$Item(fun, args));
    if ($0185bf00fa9bfdb8$var$queue.length === 1 && !$0185bf00fa9bfdb8$var$draining) $0185bf00fa9bfdb8$var$runTimeout($0185bf00fa9bfdb8$var$drainQueue);
};
// v8 likes predictible objects
function $0185bf00fa9bfdb8$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$0185bf00fa9bfdb8$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$0185bf00fa9bfdb8$var$process.title = 'browser';
$0185bf00fa9bfdb8$var$process.browser = true;
$0185bf00fa9bfdb8$var$process.env = {};
$0185bf00fa9bfdb8$var$process.argv = [];
$0185bf00fa9bfdb8$var$process.version = ''; // empty string to avoid regexp issues
$0185bf00fa9bfdb8$var$process.versions = {};
function $0185bf00fa9bfdb8$var$noop() {}
$0185bf00fa9bfdb8$var$process.on = $0185bf00fa9bfdb8$var$noop;
$0185bf00fa9bfdb8$var$process.addListener = $0185bf00fa9bfdb8$var$noop;
$0185bf00fa9bfdb8$var$process.once = $0185bf00fa9bfdb8$var$noop;
$0185bf00fa9bfdb8$var$process.off = $0185bf00fa9bfdb8$var$noop;
$0185bf00fa9bfdb8$var$process.removeListener = $0185bf00fa9bfdb8$var$noop;
$0185bf00fa9bfdb8$var$process.removeAllListeners = $0185bf00fa9bfdb8$var$noop;
$0185bf00fa9bfdb8$var$process.emit = $0185bf00fa9bfdb8$var$noop;
$0185bf00fa9bfdb8$var$process.prependListener = $0185bf00fa9bfdb8$var$noop;
$0185bf00fa9bfdb8$var$process.prependOnceListener = $0185bf00fa9bfdb8$var$noop;
$0185bf00fa9bfdb8$var$process.listeners = function(name) {
    return [];
};
$0185bf00fa9bfdb8$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$0185bf00fa9bfdb8$var$process.cwd = function() {
    return '/';
};
$0185bf00fa9bfdb8$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$0185bf00fa9bfdb8$var$process.umask = function() {
    return 0;
};


'use strict';
function $66e1b8c3059c3a3e$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $66e1b8c3059c3a3e$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = '';
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf('/');
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = '';
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = '';
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += '/..';
                    else res = '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += '/' + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $66e1b8c3059c3a3e$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $66e1b8c3059c3a3e$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = '';
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $0185bf00fa9bfdb8$exports.cwd();
                path = cwd;
            }
            $66e1b8c3059c3a3e$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + '/' + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $66e1b8c3059c3a3e$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return '/' + resolvedPath;
            else return '/';
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return '.';
    },
    normalize: function normalize(path) {
        $66e1b8c3059c3a3e$var$assertPath(path);
        if (path.length === 0) return '.';
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $66e1b8c3059c3a3e$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = '.';
        if (path.length > 0 && trailingSeparator) path += '/';
        if (isAbsolute) return '/' + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $66e1b8c3059c3a3e$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return '.';
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $66e1b8c3059c3a3e$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += '/' + arg;
            }
        }
        if (joined === undefined) return '.';
        return $66e1b8c3059c3a3e$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $66e1b8c3059c3a3e$var$assertPath(from);
        $66e1b8c3059c3a3e$var$assertPath(to);
        if (from === to) return '';
        from = $66e1b8c3059c3a3e$var$posix.resolve(from);
        to = $66e1b8c3059c3a3e$var$posix.resolve(to);
        if (from === to) return '';
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = '';
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += '..';
            else out += '/..';
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $66e1b8c3059c3a3e$var$assertPath(path);
        if (path.length === 0) return '.';
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? '/' : '.';
        if (hasRoot && end === 1) return '//';
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
        $66e1b8c3059c3a3e$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return '';
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return '';
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $66e1b8c3059c3a3e$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== 'object') throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $66e1b8c3059c3a3e$var$_format('/', pathObject);
    },
    parse: function parse(path) {
        $66e1b8c3059c3a3e$var$assertPath(path);
        var ret = {
            root: '',
            dir: '',
            base: '',
            ext: '',
            name: ''
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = '/';
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = '/';
        return ret;
    },
    sep: '/',
    delimiter: ':',
    win32: null,
    posix: null
};
$66e1b8c3059c3a3e$var$posix.posix = $66e1b8c3059c3a3e$var$posix;
$66e1b8c3059c3a3e$exports = $66e1b8c3059c3a3e$var$posix;


var $0f457cceddf61bec$import_meta = Object.assign(Object.create(null), {
    url: "file:///../painbrush/src/font/font.ts"
});
const $0f457cceddf61bec$export$fa7395143ba9d9c = ()=>(0, $eca075ad100d834d$exports.readFile)((0, (/*@__PURE__*/$parcel$interopDefault($66e1b8c3059c3a3e$exports))).resolve($0f457cceddf61bec$import_meta.dirname, `../../static/poxel.pxfont`));
const $0f457cceddf61bec$export$dddb818be04fe30a = (charmap)=>(c)=>{
        if (c in charmap) return charmap[c];
        const upper = c.toUpperCase();
        if (upper in charmap) return charmap[upper];
        const lower = c.toLowerCase();
        if (lower in charmap) return charmap[lower];
        return charmap[`?`] ?? charmap[`X`] ?? charmap[`x`] ?? charmap[` `];
    };
const $0f457cceddf61bec$export$26ca5b065308b0d1 = async (handle, charResolver = $0f457cceddf61bec$export$dddb818be04fe30a)=>{
    const chars = await $0f457cceddf61bec$var$unpackFontHandle(handle);
    const charmap = Object.fromEntries(chars.alphabet.split(``).map((l, index)=>{
        const char = chars.characters[index];
        return [
            l,
            {
                channels: 1,
                data: char[1],
                width: char[0],
                height: chars.metrics.height
            }
        ];
    }));
    charmap[` `] = {
        channels: 1,
        data: [],
        width: chars.metrics.spaces,
        height: 0
    };
    const getCharacter = charResolver(charmap);
    const getMetrics = ()=>chars.metrics;
    return {
        getCharacter: getCharacter,
        getMetrics: getMetrics
    };
};
const $0f457cceddf61bec$var$unpackFontHandle = async (handle)=>{
    const file = await handle;
    if (file instanceof Object && `alphabet` in file) return file;
    return JSON.parse((await handle).toString());
};


const $df021a129ad155ea$export$26ca5b065308b0d1 = (0, $0f457cceddf61bec$export$26ca5b065308b0d1);
const $df021a129ad155ea$export$fa7395143ba9d9c = (0, $0f457cceddf61bec$export$fa7395143ba9d9c);
const $df021a129ad155ea$export$dddb818be04fe30a = (0, $0f457cceddf61bec$export$dddb818be04fe30a);


const $ef4c3eb9f5926687$export$e119fafa9b9ac050 = async (poxelHandle, lucasHandle)=>{
    const [POXEL, LUCAS] = await Promise.all([
        poxelHandle,
        lucasHandle
    ].map((f)=>(0, $df021a129ad155ea$export$26ca5b065308b0d1)(f)));
    return async ({ bgColor: bgColor, pos: pos, posY: posY, zoom: zoom })=>{
        const sun = (0, $5f1f5d71b8f7bfcb$export$b88056449f3c8af9).blank({
            x: 30,
            y: 30
        }, (0, $1e0e3a956a824c28$export$da5d6544e8c27bc1).border(3, 0xffff00));
        const text = (0, $5f1f5d71b8f7bfcb$export$b88056449f3c8af9).text('the quick brown spirindolious fox jumps over the lazy dog!? () THE QUICK BROWN FOX JUMPS OVER THE LAZY DOG\nWhy are you reading this far you are not supposed to be reading this stop', POXEL, (0, $1e0e3a956a824c28$export$da5d6544e8c27bc1).solidFill(0xffffff), {
            maxLengthPx: 200
        });
        const bg = (0, $5f1f5d71b8f7bfcb$export$b88056449f3c8af9).blank({
            x: 280,
            y: 360
        }, (index, layer)=>{
            const { x: x, y: y } = (0, $8eba8339316108f6$export$94c12620b65d3208)(index, layer);
            return (0, $1e0e3a956a824c28$export$6d1b0a04fee90d44).fromRGB(x / layer.x * 255, y / layer.y * 255, bgColor);
        });
        const clock = (0, $5f1f5d71b8f7bfcb$export$abb141da9ad8bea6).scale((0, $5f1f5d71b8f7bfcb$export$b88056449f3c8af9).text(Date.now().toString(), LUCAS, (0, $1e0e3a956a824c28$export$da5d6544e8c27bc1).solidFill((0, $3c901d31e89c6ceb$export$b2b4e19872dae74).WHITE), {
            breakLinesOn: '',
            maxLengthPx: 50
        }), {
            x: zoom,
            y: zoom
        });
        const clockShadow = (0, $5f1f5d71b8f7bfcb$export$abb141da9ad8bea6).paint(clock, (existingColor)=>(0, $1e0e3a956a824c28$export$4f1b4fd0a80ed3b5)(existingColor) ? ()=>existingColor : (0, $1e0e3a956a824c28$export$da5d6544e8c27bc1).solidFill(0x000000));
        const clockWithShadow = (0, $5f1f5d71b8f7bfcb$export$b724cf1b0ea821f5).overlayStack([
            clock
        ], [
            clockShadow,
            {
                offset: {
                    x: 2,
                    y: 2
                }
            }
        ], [
            (0, $5f1f5d71b8f7bfcb$export$b88056449f3c8af9).blankWithAlpha({
                x: clock.x + 2,
                y: clock.y + 2
            })
        ]);
        /*
const images = overlayLayersOver(
  [makeImageLayer(await readFile("./test-junk/goomba-rgb.bmp"))],
  [
    makeImageLayer(await readFile("./test-junk/goomba-24.bmp")),
    {
      offset: [16, 0],
    },
  ],
  [
    makeImageLayer(await readFile("./test-junk/goomba-8.bmp")),
    {
      offset: [32, 0],
    },
  ],
  [makeBlankLayerWithAlpha([16 * 3, 16])],
) as Layer;
 */ const withTitle = (layer, title)=>{
            const titleLayer = (0, $5f1f5d71b8f7bfcb$export$b88056449f3c8af9).text(title.toUpperCase(), POXEL, (0, $1e0e3a956a824c28$export$da5d6544e8c27bc1).solidFill((0, $3c901d31e89c6ceb$export$b2b4e19872dae74).BLACK));
            const gap = 4;
            return (0, $5f1f5d71b8f7bfcb$export$b724cf1b0ea821f5).overlayStack([
                titleLayer
            ], [
                layer,
                {
                    offset: {
                        x: 0,
                        y: titleLayer.y + gap
                    }
                }
            ], [
                (0, $5f1f5d71b8f7bfcb$export$b88056449f3c8af9).blankWithAlpha({
                    x: Math.max(titleLayer.x, layer.x),
                    y: titleLayer.y + gap + layer.y
                })
            ]);
        };
        const textWithTitle = withTitle(text, 'little text');
        const clockWithTitle = withTitle(clockWithShadow, 'Clock');
        // const imagesWithTitle = withTitle(
        //   scaleLayer(images, [6, 12]),
        //   "Goombas",
        // );
        const layers = (0, $5f1f5d71b8f7bfcb$export$b724cf1b0ea821f5).overlayStack([
            sun,
            {
                offset: {
                    x: pos,
                    y: posY
                }
            }
        ], [
            textWithTitle,
            {
                offset: {
                    x: 10,
                    y: 10
                }
            }
        ], [
            clockWithTitle,
            {
                offset: {
                    x: 10,
                    y: 10 + textWithTitle.y + 10
                }
            }
        ], // [
        //   imagesWithTitle,
        //   {
        //     offset: [
        //       10,
        //       10 + textWithTitle.height + 10 + clockWithTitle.height + 10,
        //     ],
        //   },
        // ],
        [
            bg
        ]);
        return (0, $758b13dad9bc33fb$export$cf629b29f6b8313d)(layers);
    };
};


const $b4e14b6b8da86996$var$init = async ()=>{
    const sliders = [
        ...document.querySelectorAll('input')
    ].map((input)=>parseFloat(input.value));
    let src = '';
    const renderImage = await (0, $ef4c3eb9f5926687$export$e119fafa9b9ac050)((0, (/*@__PURE__*/$parcel$interopDefault($7d29c8b824b6496c$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($5de14f50af6b7750$exports))));
    const updateImgTag = async ()=>{
        let img = await renderImage({
            bgColor: sliders[0],
            pos: sliders[1],
            posY: sliders[2],
            zoom: sliders[3]
        });
        requestAnimationFrame(async ()=>{
            // @ts-expect-error
            const imgBlob = new Blob([
                img
            ], {
                type: 'image/bmp'
            });
            URL.revokeObjectURL(src);
            src = URL.createObjectURL(imgBlob);
            document.querySelector('img').src = src;
        });
    };
    [
        ...document.querySelectorAll('input')
    ].map((input, index)=>input.addEventListener('input', (ev)=>{
            sliders[index] = parseFloat(ev.target.value);
            updateImgTag();
        }));
    updateImgTag();
};
$b4e14b6b8da86996$var$init();


//# sourceMappingURL=browser-ex.afd0e7e1.js.map
